import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getSectionWiseSongs } from "../Redux/Actions/eventData";
import {
  addSongRequest,
  getAllCategorySongs,
  updateSongOrder,
  submitSongChoices,
  deleteSong,
} from "../Redux/Actions/songs";
import { capitalize } from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import { Formik, Field, ErrorMessage, Form as FormikForm } from "formik";
import * as Yup from "yup";
import DragDropTable from "../Components/DragDropTable";
import { genreOptions } from "./Home";

export default function SongList() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const eventId = urlParams.get("eventId");
  const sectionId = urlParams.get("section");
  const userData = useSelector((e) => e.userAuth.userList);

  const songsAsperEventAndSection = useSelector(
    (e) => e.eventAuth.sectionWiseSongList
  );

  const songAllList = useSelector((e) => e.songAuth.allCategorySongList);

  // const getSectionWiseSongsData = useSelector(
  //   (state) => state.eventAuth?.sectionWiseSongList || []
  // );

  const [selectedSection, setSelectedSection] = useState(null);

  const [songsBySection, setSongsBySection] = useState({});

  const [currentPage, setCurrentPage] = useState(0);

  const [songsOrder, setSongsOrder] = useState(songAllList?.songs || []);

  const [show, setShow] = useState(false);
  const [secondShow, setSecondShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRequestSongConfirm, setShowRequestSongConfirm] = useState(false);
  const [requestSongInitialSection, setRequestSongInitialSection] = useState("");
  const [pendingRequestSongSection, setPendingRequestSongSection] = useState("");
  const [requestSongNotice, setRequestSongNotice] = useState({
    title: "Max Songs Reached",
    message: "You already have the maximum songs allowed for this section.",
  });

  const totalEntries = songAllList?.totalSongs ?? 0;
  const defaultEntriesPerPage = 10;
  const getSectionLimit = (sectionName) => {
    const section = songsAsperEventAndSection?.eventSection?.eventSubSection?.find(
      (subSection) => subSection.section.sectionName === sectionName
    );

    return section?.section?.totalSongs || defaultEntriesPerPage;
  };
  const entriesPerPage = getSectionLimit(selectedSection);
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const songs = songsBySection[selectedSection] || [];
  const isSingleItem = songsOrder?.length === 1;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSecondClose = () => setSecondShow(false);
  const handleSecondShow = () => setSecondShow(true);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [isLocked, setIsLocked] = useState(userData?.islocked || false);

  useEffect(() => {
    setIsLocked(userData?.islocked || false);
  }, [userData]);

  const validationSchema = Yup.object({
    title: Yup.string().required("title is required"),
    artist: Yup.string().required("artist is required"),
    section: Yup.string().required("section is required"),
  });

  const initialValues = {
    title: "",
    artist: "",
    section: "",
    url: "",
    comment: "",
  };
  const requestSongInitialValues = {
    ...initialValues,
    section: requestSongInitialSection,
  };

  const handlePageChange = (page) => {
    const eventId = songsAsperEventAndSection._id;
    const subSection =
      songsAsperEventAndSection.eventSection.eventSubSection.find(
        (subSection) => subSection.section.sectionName === selectedSection
      );
    const sectionId = subSection?.section?._id;

    if (sectionId) {
      const url = new URL(window.location.href);
      url.searchParams.set("eventId", eventId);
      url.searchParams.set("section", sectionId);
      url.searchParams.set("page", page);
      window.history.pushState({}, "", url);

      dispatch(
        getAllCategorySongs({
          eventId,
          section: sectionId,
          page,
          limit: entriesPerPage,
        })
      );
    }
    setCurrentPage(page);
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination || source.index === destination.index) {
      return;
    }
    const reorderedSongs = Array.from(songsOrder);
    const [movedSong] = reorderedSongs.splice(source.index, 1);
    reorderedSongs.splice(destination.index, 0, movedSong);
    setSongsOrder(reorderedSongs);
    let orderedListIds = reorderedSongs.map((res) => res._id);

    let data = {
      eventId,
      eventType: songsAsperEventAndSection?.eventSection?.eventType?._id,
      section: sectionId,
      page: 0,
      limit: entriesPerPage,
      songs: orderedListIds,
    };

    setTimeout(() => {
      dispatch(updateSongOrder(data));
    }, 500);
  };

  function normalizeText(str = "") {
    return str.replace(/[\u2018\u2019]/g, "'");
  }

  const handleSubmit = async (values) => {
    values["event"] = eventId;
    // const subSection =
    //   songsAsperEventAndSection.eventSection.eventSubSection.find(
    //     (subSection) => subSection.section.sectionName === values.section
    //   );

    // values.section = subSection?.section?._id;
    values['title'] = normalizeText(values.title)
    try {
      await dispatch(addSongRequest(values)).then(() => handleSecondClose());
    } catch (error) {
      // toast.error(error);
    }
  };

  const handleSectionClick = (sectionName) => {

    console.log('====01112399932323', filteredSections.find((section) => section.sectionName === sectionName));

    console.log('=----=', sectionName);
    const eventId = songsAsperEventAndSection._id;
    const subSection =
      songsAsperEventAndSection.eventSection.eventSubSection.find(
        (subSection) => subSection.section.sectionName === sectionName
      );

    if (subSection) {
      const sectionId = subSection?.section?._id;

      setSelectedSection(sectionName);
      setCurrentPage(0);

      const url = new URL(window.location.href);
      url.searchParams.set("eventId", eventId);
      url.searchParams.set("section", sectionId);
      url.searchParams.set("page", 0);
      window.history.pushState({}, "", url);

      dispatch(
        getAllCategorySongs({
          eventId,
          section: sectionId,
          page: 0,
          limit: getSectionLimit(sectionName),
        })
      );
    }
  };

  useEffect(() => {
    if (songsAsperEventAndSection) {
      const sections = {};

      songsAsperEventAndSection?.eventSection?.eventSubSection?.forEach(
        (subSection) => {
          const sectionName = subSection.section.sectionName;

          sections[sectionName] = subSection.songs;
        }
      );
      setSongsBySection(sections);

      if (Object.keys(sections).length > 0) {
        setSelectedSection(Object.keys(sections)[0]);
      }
    }
  }, [songsAsperEventAndSection]);

  useEffect(() => {
    dispatch(getSectionWiseSongs({ page: 0, limit: 10 }));
  }, [dispatch]);

  useEffect(() => {
    setTimeout(() => {
      if (songAllList?.songs?.length) {
        setSongsOrder(songAllList?.songs);
      }
    }, 300);
  }, [songAllList]);

  const Initialize = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const eventId = urlParams.get("eventId");
      const sectionId = urlParams.get("section");
      const page = Number(urlParams.get("page")) || 0;

      if (eventId && sectionId) {
        const section =
          songsAsperEventAndSection?.eventSection?.eventSubSection.find(
            (subSection) => subSection.section._id === sectionId
          );

        if (section) {
          setSelectedSection(section.section.sectionName);
          setCurrentPage(page);

          dispatch(
            getAllCategorySongs({
              eventId,
              section: sectionId,
              page,
              limit: section.section.totalSongs || defaultEntriesPerPage,
            })
          );
        }
      } else if (songsAsperEventAndSection) {
        const firstSection =
          songsAsperEventAndSection?.eventSection?.eventSubSection[0];
        if (firstSection) {
          const firstEventId = songsAsperEventAndSection._id;
          const firstSectionId = firstSection.section._id;

          setSelectedSection(firstSection.section.sectionName);
          setCurrentPage(0);

          const url = new URL(window.location.href);
          url.searchParams.set("eventId", firstEventId);
          url.searchParams.set("section", firstSectionId);
          url.searchParams.set("page", 0);
          window.history.pushState({}, "", url);

          dispatch(
            getAllCategorySongs({
              eventId: firstEventId,
              section: firstSectionId,
              page: 0,
              limit: firstSection.section.totalSongs || defaultEntriesPerPage,
            })
          );
        }
      }
    } catch (error) { }
  };

  useEffect(() => {
    Initialize();
    // const urlParams = new URLSearchParams(window.location.search);
    // const eventId = urlParams.get("eventId");
    // const sectionId = urlParams.get("section");
    // const page = Number(urlParams.get("page")) || 0;

    // if (eventId && sectionId) {
    //   const section =
    //     songsAsperEventAndSection?.eventSection?.eventSubSection.find(
    //       (subSection) => subSection.section._id === sectionId
    //     );

    //   if (section) {
    //     setSelectedSection(section.section.sectionName);
    //     setCurrentPage(page);

    //     dispatch(
    //       getAllCategorySongs({
    //         eventId,
    //         section: sectionId,
    //         page,
    //         limit: entriesPerPage,
    //       })
    //     );
    //   }
    // } else if (songsAsperEventAndSection) {
    //   const firstSection =
    //     songsAsperEventAndSection?.eventSection?.eventSubSection[0];
    //   if (firstSection) {
    //     const firstEventId = songsAsperEventAndSection._id;
    //     const firstSectionId = firstSection.section._id;

    //     setSelectedSection(firstSection.section.sectionName);
    //     setCurrentPage(0);

    //     const url = new URL(window.location.href);
    //     url.searchParams.set("eventId", firstEventId);
    //     url.searchParams.set("section", firstSectionId);
    //     url.searchParams.set("page", 0);
    //     window.history.pushState({}, "", url);

    //     dispatch(
    //       getAllCategorySongs({
    //         eventId: firstEventId,
    //         section: firstSectionId,
    //         page: 0,
    //         limit: entriesPerPage,
    //       })
    //     );
    //   }
    // }
  }, [dispatch, songsAsperEventAndSection]);

  const handleSubmitChoices = async () => {
    try {
      await dispatch(submitSongChoices({ isLocked: true, eventId })).unwrap();

      setIsLocked(true);

      setIsModalVisible(false);
    } catch (error) {
      console.error("Failed to submit choices:", error);
    }
  };

  const handleDeleteSong = (deletedId) => {
    Initialize();
    dispatch(getSectionWiseSongs({ page: 0, limit: 10 }));
    setSongsOrder((prev) => prev.filter((song) => song._id !== deletedId));
  };

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [selectedSong, setSelectedSong] = useState(null);
  const handleShow3 = (songData) => {
    setSelectedSong(songData);
    setShow2(true);
  };

  const handleConfirmDelete = () => {
    if (!selectedSong) return;
    dispatch(
      deleteSong({ songID: selectedSong?._id, eventId: selectedSong?.eventId })
    )
      .unwrap()
      .then(() => {
        handleDeleteSong(selectedSong?._id);
        handleClose2();
        setSelectedSong(null);
      })
      .catch((err) => {
        console.error("Failed to delete song:", err);
      });
  };

  // const filteredSections = songsAsperEventAndSection?.sections?.filter((section) => {
  //   const sectionName = section?.sectionName;
  //   return Object.keys(songsBySection).includes(sectionName);
  // });

  const sectionOrder = Object.keys(songsBySection);

  const filteredSections = sectionOrder
    .map((name) => {
      const subSection = songsAsperEventAndSection?.eventSection?.eventSubSection?.find(
        (sub) => sub.section.sectionName === name
      );
      if (!subSection) return null;

      return {
        section_id: subSection.section._id,
        sectionName: subSection.section.sectionName,
        totalSongs: subSection.section.totalSongs || 0,
        selectedSongs: subSection.songs?.length || 0,
      };
    })
    .filter(Boolean);

  const ceremonyRequestSections = [
    "pre-ceremony",
    "bridal party entrance",
    "signing of the register",
    "walk out",
  ];

  const canRequestSongForSection = (sectionName = "") => {
    const normalizedSectionName = sectionName.toLowerCase();

    return ceremonyRequestSections.some((allowedSection) =>
      normalizedSectionName.includes(allowedSection)
    );
  };

  const showRequestSongNotice = (title, message) => {
    setRequestSongNotice({ title, message });
    setShowModal(true);
  };

  const requiresRequestSongConfirmation = (sectionId) => {
    const sectionName = filteredSections
      .find((section) => String(section.section_id) === String(sectionId))
      ?.sectionName?.toLowerCase();

    return (
      sectionName?.includes("pre-ceremony") ||
      sectionName?.includes("signing of the register")
    );
  };

  const selectedSectionDetails = filteredSections.find(
    (section) => section.sectionName === selectedSection
  );
  const selectedSectionName =
    selectedSectionDetails?.sectionName?.toLowerCase() || "";
  const isPrioritySongSection =
    selectedSectionName.includes("pre-ceremony") ||
    selectedSectionName.includes("signing of the register") ||
    selectedSectionName.includes("signing of the registrar");
  const isDrinksReceptionSection =
    selectedSectionName.includes("drinks reception");
  const hasMultipleSongSlots = (selectedSectionDetails?.totalSongs || 0) > 1;
  const songListNote = isDrinksReceptionSection
    ? "Please feel free to select some songs for me to choose from, no more than the specified number, however I do also like to have the freedom to read the crowd on the day."
    : isPrioritySongSection && hasMultipleSongSlots
      ? "Please arrange your songs in the order that you would like them performed, as I may not have time to get through all songs in each section. If you have requested any songs, these must be placed as song 1 or 2 when used during the Pre-Ceremony or Signing of the Register sections."
      : "";

  console.log('====filtered sections', filteredSections);




  return (
    <Layout className="main-wrap">
      <Container fluid className="mt-4 p-0 custom-boxx">
        <div className="comm-top-title-sec">
          <h2>Song List</h2>
          <div className="home-welcome-txt">
            {/* Request a Song Button */}
            <button
              className={`white-bg ${isLocked
                ? "bg-secondary-subtle border-secondary text-secondary pe-none border-0"
                : ""
                }`}
              // className="white-bg"
              disabled={isLocked}
              onClick={() => {
                if (isLocked) return;
                const selectedSubSection =
                  songsAsperEventAndSection?.eventSection?.eventSubSection.find(
                    (subSection) => {
                      return subSection.section.sectionName === selectedSection;
                    }
                  );

                const currentSongs = selectedSubSection?.songs?.length || 0;
                const maxSongs = selectedSubSection?.section?.totalSongs || 0;
                const sectionName = selectedSubSection?.section?.sectionName;

                if (!canRequestSongForSection(sectionName)) {
                  showRequestSongNotice(
                    "Song Requests Not Available",
                    "Song requests are only available for ceremony sections."
                  );
                } else if (currentSongs >= maxSongs) {
                  showRequestSongNotice(
                    "Max Songs Reached",
                    "You already have the maximum songs allowed for this section."
                  );
                } else if (
                  requiresRequestSongConfirmation(
                    selectedSubSection?.section?._id
                  )
                ) {
                  setPendingRequestSongSection(
                    selectedSubSection?.section?._id || ""
                  );
                  setShowRequestSongConfirm(true);
                } else {
                  setRequestSongInitialSection(
                    selectedSubSection?.section?._id || ""
                  );
                  setSecondShow(true);
                }
              }}
            >
              Request a Song
            </button>

            {/* Update Selection */}
            <button
              class={`color-bg ${isLocked
                ? "bg-secondary-subtle border-secondary text-secondary pe-none"
                : ""
                }`}
              // className="color-bg"
              disabled={isLocked}
              onClick={() => {
                if (isLocked) return;
                const eventId = songsAsperEventAndSection?._id;
                const selectedSubSection =
                  songsAsperEventAndSection?.eventSection?.eventSubSection.find(
                    (subSection) =>
                      subSection.section.sectionName === selectedSection
                  );
                const sectionId = selectedSubSection?.section?._id;
                const maxSong = selectedSubSection?.section?.totalSongs;

                if (eventId && sectionId) {
                  Navigate(
                    `/all-songs/${eventId}/${sectionId}/${currentPage}/${maxSong}`
                  );
                }
              }}
            >
              Update Selection
            </button>

            {/* Submit Choices Button */}
            <button
              // className="white-bg"
              className="color-bg btn-purple"
              onClick={() => setIsModalVisible(true)}
              disabled={isLocked}
            >
              Submit Choices
            </button>
          </div>
        </div>
        <Row>

          <Col lg={4}>
            <div className="songlist-selection">
              <h4>Sections</h4>
              <p>Please select a section of your event to add songs to.</p>
              <ul>
                {Object.keys(songsBySection).map((section) => (
                  <li
                    key={section}
                    className={selectedSection === section ? "active" : ""}
                    onClick={() => handleSectionClick(section, selectedSection)}
                    style={{ cursor: "pointer" }}
                  >
                    {capitalize(section)}
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          <Col lg={8} className="mt-2 mt-lg-0">
            {songListNote && (
              <p className="song-order-note">{songListNote}</p>
            )}
            {songAllList?.songs?.length === 0 ? (
              <div className="filters mt-0">
                <div className="inner-filter-field">
                  <div className="table-responsive">
                    <Table size="sm" className="table-cmn">
                      <thead className="d-none">
                        <tr>
                          <th>Song name</th>
                          <th>Artist</th>
                          <th>Genre</th>
                          <th>Arrange Order</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="5" className="no-data-found text-center">
                            <button
                              // className="add-songs-btn"
                              className={`white-bg ${isLocked
                                ? "bg-secondary-subtle border-secondary text-secondary pe-none border-0"
                                : ""
                                }`}
                              disabled={isLocked}
                              onClick={() => {
                                const eventId = songsAsperEventAndSection?._id;
                                const selectedSubSection =
                                  songsAsperEventAndSection?.eventSection?.eventSubSection.find(
                                    (subSection) =>
                                      subSection.section.sectionName ===
                                      selectedSection
                                  );
                                const sectionId =
                                  selectedSubSection?.section?._id;
                                const maxSong =
                                  selectedSubSection?.section?.totalSongs;

                                if (eventId && sectionId) {
                                  Navigate(
                                    `/all-songs/${eventId}/${sectionId}/${currentPage}/${maxSong}`
                                  );
                                }
                              }}
                            >
                              Add Songs
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            ) : (
              <div className="filters mt-0">
                <div className="inner-filter-field">
                  <div class="table-responsive">
                    <Table size="sm" className="table-cmn">
                      <thead>
                        <tr>
                          <th>
                            <div className="user-checkbox">Song name</div>
                          </th>
                          <th>Artist</th>
                          <th>Genre</th>
                          <th>Arrange Order</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      {!isSingleItem ? (
                        <DragDropTable
                          songsOrder={songsOrder}
                          handleDragEnd={handleDragEnd}
                          isLocked={isLocked}
                          onDeleteSuccess={handleDeleteSong}
                        />
                      ) : (
                        <tbody>
                          {songsOrder.map((song, index) => (
                            <tr key={song?.id || index}>
                              <td>{song?.title}</td>
                              <td>{song?.artist}</td>
                              {/* <td>{song?.genre}</td> */}
                              <td>{genreOptions[song?.genre] || "N/A"}</td>
                              <td>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M5 7H19"
                                    stroke="#979699"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <path
                                    d="M5 12H19"
                                    stroke="#979699"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <path
                                    d="M5 17H19"
                                    stroke="#979699"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                </svg>
                              </td>
                              <td>
                                <button
                                  className={`btn btn-sm ${isLocked
                                    ? "btn-secondary pe-none opacity-50"
                                    : "btn-outline-danger"
                                    }`}
                                  onClick={() => !isLocked && handleShow3(song)}
                                  disabled={isLocked}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </Table>

                    {songAllList?.totalSongs > 0 && (
                      <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        totalEntries={totalEntries}
                        entriesPerPage={entriesPerPage}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Container>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Request a change</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Lorem ipsum dolor sit"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleClose}>
            Request
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={secondShow} onHide={handleSecondClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Request a Song</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Formik
              initialValues={requestSongInitialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ handleSubmit, errors, isValid, values }) => (
                  <FormikForm onSubmit={handleSubmit}>
                    <div className="modal-cmn-form-set">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Title</Form.Label>
                      <Field
                        name="title"
                        type="text"
                        className="form-control"
                        placeholder="Enter song title"
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Artist</Form.Label>
                      <Field
                        name="artist"
                        type="text"
                        className="form-control"
                        placeholder="Enter song artist"
                      />
                      <ErrorMessage
                        name="artist"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Section</Form.Label>
                      <Field
                        id="category"
                        as="select"
                        name="section"
                        className={
                          values?.section === ""
                            ? "form-select placeholder-select"
                            : "form-select filled-select"
                        }
                      >
                        <option value="" disabled>
                          Select section
                        </option>
                        {/* {Object.entries(songsBySection).map(([key, value]) => (
                          <option key={key} value={key}>
                            {key}
                          </option>
                        ))} */}
                        {/* {songsAsperEventAndSection?.sections?.map((section) => {
                          const isDisabled =
                            section?.selectedSongs >= section?.totalSongs;
                          return (
                            <option
                              key={section?.section_id || section?.sectionName}
                              value={section?.section_id}
                              disabled={isDisabled}
                              className={isDisabled ? "disabled-option" : ""}
                            >
                              {section?.sectionName}
                            </option>
                          );
                        })} */}
                        {filteredSections?.map((section) => {
                          const isDisabled =
                            section?.selectedSongs >= section?.totalSongs ||
                            !canRequestSongForSection(section?.sectionName);


                          return (
                            <option
                              key={section?.section_id || section?.sectionName}
                              value={section?.section_id}
                              disabled={isDisabled}
                              className={isDisabled ? "disabled-option" : ""}
                            >
                              {section?.sectionName}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="section"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Youtube or Spotify URL (Optional)</Form.Label>
                      <Field
                        name="url"
                        type="url"
                        className="form-control"
                        placeholder="Enter song url"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Comments</Form.Label>
                      <Field
                        name="comment"
                        as="textarea"
                        className="form-control"
                        placeholder="Enter comments"
                        rows={3}
                      />
                    </Form.Group>
                    </div>
                    <Modal.Footer className="border-none justify-content-center">
                      <button className="secondary" onClick={handleSecondClose}>
                        Close
                      </button>
                      <button className="primary" type="submit">
                        Request a Song
                      </button>
                    </Modal.Footer>
                  </FormikForm>
              )}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showRequestSongConfirm}
        onHide={() => {
          setShowRequestSongConfirm(false);
          setRequestSongInitialSection("");
          setPendingRequestSongSection("");
        }}
        centered
      >
        <Modal.Body className="py-4 text-center">
          <p className="mb-0">
            By clicking 'I Confirm', you are confirming that your requested song
            will be placed either first or second in order of priority in this
            section
          </p>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button
            type="button"
            className="secondary"
            onClick={() => {
              setShowRequestSongConfirm(false);
              setRequestSongInitialSection("");
              setPendingRequestSongSection("");
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="primary"
            onClick={() => {
              setShowRequestSongConfirm(false);
              setRequestSongInitialSection(pendingRequestSongSection);
              setPendingRequestSongSection("");
              setSecondShow(true);
            }}
          >
            I Confirm
          </button>
        </Modal.Footer>
      </Modal>

      {/* request modal for songs for max reach */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">{requestSongNotice.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3 text-center">
          <p>{requestSongNotice.message}</p>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="primary" onClick={() => setShowModal(false)}>
            Okay
          </button>
        </Modal.Footer>
      </Modal>

      {/* modal for submit choices */}
      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)}>
        {/* <Modal show={showModal} onHide={() => setShowModal(false)}> */}
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Lock Choices</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3 text-center">
          <p>
            Pressing 'Submit Choices' will lock in the songs for ALL sections of
            your booking. Please only do this when you are happy with all of
            your song choices. Are you sure you wish to continue?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button
            className="secondary"
            onClick={() => setIsModalVisible(false)}
          >
            Cancel
          </button>
          <button
            className="primary"
            type="submit"
            onClick={handleSubmitChoices}
          >
            Submit Choices
          </button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} centered>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose2}>
            Close
          </button>
          <button className="primary" onClick={handleConfirmDelete}>
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
